'use strict';

var React = require('react'),
    Group = require('./Group'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    StampPageMixins = require('../mixins/StampPageMixins'),
    { PropTypes } = React;

var TrendingNextUp = React.createClass({
  mixins: [StampPageMixins.Feed, PureRenderMixin],

  propTypes: {
    perFirstPage: PropTypes.number.isRequired,
    itemProps: PropTypes.object,
    getItemProps: PropTypes.func
  },

  getStateFromStores() {
    return {
      stamps: this.getPage(),
      nextUpTitle: this.getNextUpTitle(),
      isExpectingPage: this.isExpectingPage()
    };
  },

  componentDidMount() {
    this.requestPage(true);
  },

  render() {
    var { nextUpTitle, stamps, isExpectingPage, isLastPage } = this.state,
        { getItemProps, itemProps } = this.props;

    return (
      <Group type='stamps'
             mode='grid'
             columns={3}
             context='page'
             title={nextUpTitle}
             items={stamps}
             itemProps={itemProps}
             getItemProps={getItemProps}
             isExpectingPage={isExpectingPage}
             isLastPage={isLastPage}
             isInvalidated={false}
             perFirstPage={this.props.perFirstPage} />
    );
  }
});

module.exports = TrendingNextUp;


/** WEBPACK FOOTER **
 ** ./organisms/TrendingNextUp.jsx
 **/